import React, { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { NOINDEX_PRIVATE_SEO } from "../../constants/siteSeo";
import { usePageSeo } from "../../hooks/usePageSeo";
import { useAccount } from "wagmi";
import LayoutOne from "../../layouts/LayoutOne";

function compactAddr(addr) {
  if (!addr || typeof addr !== "string") return "";
  const a = addr.trim();
  if (a.length < 10) return a;
  return `${a.slice(0, 6)}…${a.slice(-4)}`;
}

const Profile = () => {
  usePageSeo({
    ...NOINDEX_PRIVATE_SEO,
    title: "Wallet profile | Treydora",
    description: "On-chain collector profile — not indexed.",
  });

  const { address: routeAddress } = useParams();
  const { address: connected } = useAccount();

  const routeNorm = useMemo(
    () => (routeAddress ? String(routeAddress).toLowerCase() : ""),
    [routeAddress]
  );
  const connectedNorm = useMemo(
    () => (connected ? String(connected).toLowerCase() : ""),
    [connected]
  );
  const matches = Boolean(routeNorm && connectedNorm && routeNorm === connectedNorm);

  return (
    <LayoutOne>
      <main className="fix">
        <div className="container" style={{ marginTop: 24 }}>
          <h1>Profile</h1>
          <p style={{ color: "rgba(200,210,230,0.9)" }}>
            Wallet route: <span style={{ fontFamily: "monospace" }}>{compactAddr(routeAddress)}</span>
          </p>
          {!connected ? (
            <p>Connect your wallet (wagmi) from the site header or token sales page to verify this profile address.</p>
          ) : !matches ? (
            <p>
              Connected wallet ({compactAddr(connected)}) does not match this URL. Open{" "}
              <Link to={`/profile/${connected}`}>your profile route</Link> or connect the matching wallet.
            </p>
          ) : (
            <p>
              Connected as <strong>{compactAddr(connected)}</strong>. Koraxos collection views and balances are
              available from the <Link to="/library">library catalog</Link> and{" "}
              <Link to="/dashboard">Treydora Gateway dashboard</Link>.
            </p>
          )}
        </div>
      </main>
    </LayoutOne>
  );
};

export default Profile;
